<template>
    <div class="overview clearfix">
        <div class="right-col">
            <overview-right-account-info
              @send-indexdata="sendIndexDataHandle"
            ></overview-right-account-info>
        </div>
        <div class="left-col">
            <data-statistics-general
                    :data-statistics="accountInfo"
            ></data-statistics-general>
            <line-chart-and-symbol-chart></line-chart-and-symbol-chart>
            <order-list></order-list>
        </div>
    </div>
</template>

<script>
  import overviewRightAccountInfo from '@/components/user/details/general/overview/overviewRightAccountInfo'
  import accountIndexData from '@/components/common/accountIndexData'
  import orderList from '@/components/user/details/common/order/orderList'
  import lineChartAndSymbolChart from '@/components/user/details/common/earings/lineChartAndSymbolChart'
    import dataStatisticsGeneral from '@/components/user/details/general/overview/dataStatistics/dataStatisticsGeneral'
  export default {
    name: 'index',
    components:{
      dataStatisticsGeneral,
      lineChartAndSymbolChart,
      orderList,
      accountIndexData,
      overviewRightAccountInfo,
    },
    data() {
      return {
        accountInfo: {
          balance: 0,
          closeOrder: 3,
          createTime: "",
          credit: 0,
          earningRate: 0,
          enableReadOnly: 0,
          equity: 0,
          leverage: 0,
          login: 0,
          marginFree: 0,
          maxRetracement: 0,
          openOrder: 0,
          profitRate: 0,
          statProfit: 0,
          subLoginNumber: 1,
          times: 1,
        }
      };
    },
    methods: {
      sendIndexDataHandle(accountInfo) {
        this.accountInfo = accountInfo;
      }
    }
  };
</script>
<style lang="scss">

</style>
<style lang="scss" scoped>

</style>
